import Swiper, { Navigation } from 'swiper';

function imageSwiper() {
    const slider = new Swiper(".image-swiper", {
        slidesPerView: 2,
        draggable: true,
        speed: 700,
        spaceBetween: 32,
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".image-swiper-next",
            prevEl: ".image-swiper-prev",
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                spaceBetween: 70,
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 70,
            },
        },
    });
}

export { imageSwiper }